import { useEffect, useState } from "react";
import QRCode from "qrcode";

/* El QR de un texto, como SVG. SVG y no PNG: se imprime nítido a cualquier
 * tamaño, y no necesita un canvas (que en la impresora o en los tests no
 * siempre hay). Corrección «M»: aguanta una etiqueta algo gastada o con una
 * mancha de grasa, que es como van a terminar en el llavero. */
const QrLlave = ({ texto, tamano = 140, titulo }) => {
  const [svg, setSvg] = useState("");

  useEffect(() => {
    let vivo = true;
    QRCode.toString(texto, { type: "svg", margin: 1, errorCorrectionLevel: "M" })
      .then((s) => vivo && setSvg(s))
      .catch(() => vivo && setSvg(""));
    return () => {
      vivo = false;
    };
  }, [texto]);

  return (
    <div
      className="qr-llave"
      role="img"
      aria-label={titulo || texto}
      style={{ width: tamano, height: tamano }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default QrLlave;
